import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Header from '../../common/components/header';
import Sidebar from '../../common/components/sidebar';
import ListPartners from '../../partner/list-partners';

const PartnerRoutes = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Routes>
            <Route path="/" element={<ListPartners />} />
          </Routes>
        </div>
      </div>

      <>Some Footer Stuff</>
    </>
  );
};

export default PartnerRoutes;
